// extracted by mini-css-extract-plugin
export var closeButton = "_dx-1";
export var closeX = "_dx-3";
export var container = "_dx-0";
export var image = "_dx-2";